import type { StationMessage } from '@axinom/mosaic-ui';
import React from 'react';
import { ResourceStatus } from '../../../../generated/hosting-service';
import { ReadyToUseASEStationMessage } from '../common';

export const StorageAccountEnablingInProgress = {
  title:
    'The storage account is now being created, and this operation may take some minutes to complete. Please come back to this station or refresh it to check if it has been successfully created.',
  type: 'info',
} as const;

export const StorageAccountDisablingInProgress = {
  title:
    'The storage account is now being disabled, and this operation may take some minutes to complete. Please come back to this station or refresh it to check if it has been successfully disabled.',
  type: 'info',
} as const;

export const StorageAccountErrorDeleting = {
  title:
    'WARNING: An error ocurred during disabling the storage account. Check out the logs.',
  type: 'warning',
} as const;

export const StorageAccountErrorCreating = {
  title:
    'WARNING: An error ocurred during creating the storage account. Check out the logs.',
  type: 'warning',
} as const;

export const StorageAccountIsReadyToUse = {
  title: (
    <>
      <ReadyToUseASEStationMessage />
    </>
  ),
  type: 'info',
} as const;

const StatusMessageMap: {
  [key in ResourceStatus]: StationMessage | undefined;
} = {
  [ResourceStatus.CreatePending]: StorageAccountEnablingInProgress,
  [ResourceStatus.DeletePending]: StorageAccountDisablingInProgress,
  [ResourceStatus.Ready]: StorageAccountIsReadyToUse,
  [ResourceStatus.DeleteError]: StorageAccountErrorDeleting,
  [ResourceStatus.CreateError]: StorageAccountErrorCreating,
  [ResourceStatus.DeleteCompleted]: undefined,
  [ResourceStatus.ScaledDown]: undefined,
};

export const resolveStationMessage = (
  status: ResourceStatus,
): StationMessage | undefined => {
  return StatusMessageMap[status];
};
